import { render } from "./PaneContainer.vue?vue&type=template&id=00329e0e"
import script from "./PaneContainer.vue?vue&type=script&lang=js"
export * from "./PaneContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__